import Head from "next/head"
import {NextPage, GetStaticProps} from "next";
import {MainLayout} from "../src/components/main-layout";
import {Container, Grid, Typography, Hidden} from "@mui/material";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import Image from "next/legacy/image";
import React, {useEffect} from "react";
import {RecentUsersBox} from "../src/components/home/recent-users-box";
import {useDispatch, useSelector, wrapper} from "../src/store";
import {fetchRecentUsers} from "../src/slices/recent-users-slice";
import googleBucketLoader from "../src/lib/google-bucket-loader";
import getConfig from "next/config";


const ConceptPage: NextPage = () => {
    const {t, i18n} = useTranslation()

    const dispatch = useDispatch()
    const {recentUsers} = useSelector((state) => state.recentUsers);
    useEffect(() => {
        dispatch(fetchRecentUsers());
    }, [])

    return (
        <div>
            <Head>

                <title>{t("concept") + " | SeaCrush"}</title>
            </Head>
            <section style={{backgroundColor: "#fafafa"}}>

                <Container maxWidth='lg' sx={{pt: 6, pb: 6}}>

                    <Typography variant={"h3"} sx={{fontWeight: 400, lineHeight: 1.1, mb: 3}}
                                dangerouslySetInnerHTML={{__html: t("concept-1-title")}}/>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>

                            <Typography variant={"body1"} color={"textSecondary"}
                                        dangerouslySetInnerHTML={{__html: t("concept-1a-description")}}/>

                        </Grid>

                        <Grid item xs={12} md={7}>

                            <Image
                                loader={googleBucketLoader}
                                width={1240}
                                height={622}
                                layout={"responsive"}
                                placeholder={"blur"}
                                blurDataURL={"data:image/webp;base64,UklGRiYBAABXRUJQVlA4IBoBAADQBQCdASogABAAPm0skkWkIqGYBABABsS2AE6ZQjAFuEh/ttzGgHgC38GUcKmzO4xXL9+e8dAAAPKh9TDZbZukMI3IHJV1Tulsuhq/0MJI9Nho+qohEKC3mEyHzDoJilL6lbUNgaHEzPIScMa/GrcpooyRVmLLGbFlaYeDl//JiEU7ioMNLrv/Kq8dfvlKxacb+Gl/7oYiQDfJ+TDp8C24S3tGneMn4H0K54Tzg6t+J7q0O9Q0d8xdwWIAX5aIFHmve/ay5NmY7nbp5Jg/+RX8va6ewgZ1gPR8vt/GrD+ykSPj+4C+xYt+t6ZwhHlgpUjV2bdbI23Ev4vyBXJmu6Eheg+P5Bd+WKz5APY6/ixFKpfoyaAWRtYAAAA="}
                                src='/images/concept/IYORBank_PeopleandtheReef_TheOceanAgency_20_1240.webp'
                            />

                        </Grid>

                    </Grid>

                    <Grid container spacing={2} sx={{mt: 8}}>
                        <Grid item xs={12} md={6}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={12} md={6}>

                            <Typography variant={"h3"} sx={{fontWeight: 400, lineHeight: 1.1, mb: 3}}
                                        dangerouslySetInnerHTML={{__html: t("concept-2-title")}}/>

                        </Grid>

                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Image
                                width={920}
                                height={692}
                                layout={"responsive"}
                                placeholder={"blur"}
                                blurDataURL={"data:image/webp;base64,UklGRnwBAABXRUJQVlA4IHABAADQBwCdASogABgAPm0ukkYkIqGhKA1QgA2JbACdMoR1d5nw41q7WOTY7/RvAAMfjCoInkLc/zDSrR4qWbZxnyfo9Z2VJChjIAD++RhAis4BzbYZzSpnKEJra0kqTaJVaWhzQAPRzd0OhCMAWEe4NWUv9X/MsvNqUh/+fmflDJ6GfEZ4a0niXITvvq+pqx6d9j0oW3pHun14y4pvq/3S9Um3shPBOmUFYvovO9pyLMKy9rjpPIBn7rmOyGxEfESXnLhB57upf6EpEnTm9OhL9AHBh/Dey2xLaD9TQIghpCQbOefO2NeOXLkLvgIRNXjZBjvtwvIeETlZwZJUWUNqSn4cY0mgIKNqff7/ey88kJxTX5Gf2R6vIzYLXlI1xpS5gUAtXSqarpq3fZwVzMb6Jy5tMWeupN27BxTALmkfO2RmJWBkTAOsTPh5K1MvNSmwxZ/fKP778j3FctpxmJnnr+YiPCVJ9IUdxRtgzvrLx8AAAA=="}
                                src='/images/concept/vlad-tchompalov-450786-unsplash_920.webp'
                            />

                        </Grid>
                        <Grid item md={6}>

                            <Typography variant={"body1"} color={"textSecondary"}
                                        dangerouslySetInnerHTML={{__html: t("concept-2a-description")}}/>

                        </Grid>

                    </Grid>


                    <Typography variant={"h3"} sx={{fontWeight: 400, lineHeight: 1.1, mb: 3, mt: 10}}
                                dangerouslySetInnerHTML={{__html: t("concept-3-title")}}/>

                    <Grid container spacing={2}>
                        <Grid item md={8}>

                            <Typography variant={"body1"} color={"textSecondary"}
                                        dangerouslySetInnerHTML={{__html: t("concept-3a-description")}}/>

                            <Hidden mdDown>
                                <RecentUsersBox recentUsers={recentUsers}/>
                            </Hidden>

                        </Grid>

                        <Grid item xs={12} md={4}>
                            <video autoPlay loop muted playsInline
                                   style={{
                                       zIndex: 2,
                                       display: "block",
                                       // position: "absolute",
                                       maxWidth: "100%",
                                       height: "auto",
                                       margin: "0 auto"
                                   }}>
                                <source src={`/images/concept/Rating_video_${i18n.language}.mp4`} type='video/mp4'/>
                            </video>

                        </Grid>

                    </Grid>

                    <Hidden mdUp>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>


                                <RecentUsersBox recentUsers={recentUsers}/>

                            </Grid>


                        </Grid>
                    </Hidden>

                </Container>

            </section>
        </div>
    )
}


ConceptPage.getLayout = (page) => (
    <MainLayout>
        {page}
    </MainLayout>
);


export const getStaticProps: GetStaticProps = wrapper.getStaticProps(store => async ({params, locale}) => {

    if (getConfig().serverRuntimeConfig.prefetchData) {
        await store.dispatch(fetchRecentUsers())
    }

    return {
        props: {
            ...(await serverSideTranslations(locale as string, ["frontend"])),
        }
    };
})

export default ConceptPage
